
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Search from 'vux/src/components/search/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import InlineLoading from 'vux/src/components/inline-loading/index.vue'

import {swiper, swiperSlide} from 'vue-awesome-swiper'
import loadPage from '../../components/loadingPage'
import global from '../../../static/js/global'
export default {
data (){
return {
swiperOption: {
direction: 'horizontal',
spaceBetween: 12,
slidesPerView:'auto',
observer:true,
observeParents:true,
pagination: {
el: '.swiper-pagination',
clickable: false
}},
show_1:false,
fiterShow:false,
value:'',
surc:'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1532413887778&di=4c5590ace460fdd19fcafd9aabe91366&imgtype=0&src=http%3A%2F%2Fpic.58pic.com%2F58pic%2F15%2F57%2F84%2F70H58PICCJt_1024.jpg',
smc:'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1532413887778&di=4c5590ace460fdd19fcafd9aabe91366&imgtype=0&src=http%3A%2F%2Fpic.58pic.com%2F58pic%2F15%2F57%2F84%2F70H58PICCJt_1024.jpg',
srcs:"https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1532413887778&di=4c5590ace460fdd19fcafd9aabe91366&imgtype=0&src=http%3A%2F%2Fpic.58pic.com%2F58pic%2F15%2F57%2F84%2F70H58PICCJt_1024.jpg",
surc1:'http://i1.hexunimg.cn/2014-12-30/171900456.jpg',
srcs1:'http://i1.hexunimg.cn/2014-12-30/171900456.jpg',
imgs: [
'http://covteam.u.qiniudn.com/test16.jpg?imageView2/2/format/webp',
'http://covteam.u.qiniudn.com/test16.jpg?imageView2/2/format/webp',
'http://covteam.u.qiniudn.com/test16.jpg?imageView2/2/format/webp',
],
titles:[
'新鲜',
'本小区',
'电器'
],
list2:[],
filter1:[],
filter2:[],
filter3:[],
picList:[],
value1:'',
value2:'',
value3:'',

openid:'',
comnCode:'',
phone:'',
comnName:'',
num:0,
data:[],
msDate:1,
nIndex:'',
fliterIds:'',
fliterTypes:''
}
},
components:{
XButton,
XHeader,
Flexbox,
FlexboxItem,
Search,
Tab,
TabItem,
XImg,
swiper,
swiperSlide,
InlineLoading,
loadPage
},
mounted(){
this.openid = this.$router.history.current.query.openid;
this.phone = this.$router.history.current.query.phone;
this.comnCode = this.$router.history.current.query.comnCode;
this.comnName = this.$router.history.current.query.communityName;
let sels = this;


mobilwmtouch(document.getElementById("g1"))
document.getElementById("g1").addEventListener('touup',this.touchup,false)
function mobilwmtouch(obj){
var stoux,stouy;
var etoux,etouy;
var xdire,ydire;
obj.addEventListener("touchstart",function (e){
stoux=e.targetTouches[0].clientX;
stouy=e.targetTouches[0].clientY;

},false);
obj.addEventListener("touchend",function (e){
etoux=e.changedTouches[0].clientX;
etouy=e.changedTouches[0].clientY;
xdire=etoux-stoux;
ydire=etouy-stouy;
let chazhi=Math.abs(xdire)-Math.abs(ydire);

if(xdire>0&&chazhi>0){
console.log("right");

obj.dispatchEvent(evenzc('touright'));

}else if(ydire>0&&chazhi<0){
console.log("down");
obj.dispatchEvent(evenzc('toudown'));
}else if(xdire<0&&chazhi>0){
console.log("left");
obj.dispatchEvent(evenzc('touleft'));
}else if(ydire<0&&chazhi<0){
console.log("up");
obj.dispatchEvent(evenzc('touup'));
}
},false);
}

function evenzc(eve){
let event = '';
if (typeof document.CustomEvent === 'function') {
event = new document.CustomEvent(eve, {//自定义事件名称
bubbles: false,//是否冒泡
cancelable: false
});
if(!document["evetself"+eve]){
document["evetself"+eve]= event;
}
} else if (typeof document.createEvent === 'function') {
event = document.createEvent('HTMLEvents');
event.initEvent(eve, false, false);
if(!document["evetself"+eve]){
document["evetself"+eve]=event;
}
} else {
return false;
}

return document["evetself"+eve];

}

},
beforeMount(){
if(this.$router.history.current.path == "/fleaMarketList"){
document.title = "二手市场";
}
this.loadData(0,0,1);
},
methods:{
touchup(){
$(".am_absolt").show();
this.msDate++;
console.log(this.msDate)
this.loadData(this.msDate,1, this.msDate);
this.moreList(this.msDate,1, this.msDate);
},
tabExchange(index){//标签切换
this.nIndex = index;
let size = this.picList.length;
for(let i= 0; i < size ; i++){
this.picList.pop();

}
if(index>1){
this.moreList(index,1,1);
}else{
this.loadData(index,0,1);
}

},
getResult(){
let size = this.picList.length;
for(let i= 0; i < size ; i++){
this.picList.pop();
}

this.loadData(this.nIndex,1,1);

},
showFilter(){

this.fiterShow = true;
this.loadData(0,0,1);
let selfs = this;

$("#am_select1").find("button").click(function(){
$(this).addClass("weui-btn_primary").siblings("button").removeClass("weui-btn_primary");
selfs.value1 = $(this).html();
})
$("#am_select2").find("button").click(function(){
$(this).addClass("weui-btn_primary").siblings("button").removeClass("weui-btn_primary");
selfs.value2 = $(this).html();

})
$("#am_select3").find("button").click(function(){
$(this).addClass("weui-btn_primary").siblings("button").removeClass("weui-btn_primary");
selfs.value3 = $(this).html();
})

$("#am_reset").click(function(){
$(".am_button").find("button").removeClass("weui-btn_primary");
})
},

selectTia(){
this.picList = [];

this.loadData(this.nIndex,1,1);
this.fiterShow = false;
},
moreList(index,flag,pages){
this.show_1 = true;

let jsonData = {
firstflag: flag,
filters:[
{
filterId:this.fliterIds,
filterType:this.fliterTypes,
}
],
page:pages,
rows: 3,
isOffline:0,
goodsState:2
};
console.log("$$$$$$$$$$$$$$$$$$$$$$")
console.log(jsonData)
let url = global.host + 'secondMarket/findgoodslist';
this.$http.post(url,jsonData).then(function(res){

let picList = res.body.goods;
for(let mv in picList){
if(picList[mv].imgs.length>0){
for(let nv in picList[mv].imgs){
picList[mv].imgs[nv].minPicUrl = global.baseImg+picList[mv].imgs[nv].minPicUrl;
picList[mv].imgs[nv].maxPicUrl = global.baseImg+picList[mv].imgs[nv].maxPicUrl;
}
}
this.picList.push(picList[mv]);
}


this.show_1 = false;
$(".am_absolt").hide()

if(jsonData.rows != res.body.goods.length){
document.getElementById("g1").removeEventListener('touup',this.touchup);
}
},function(err){
console.log(err)
})
},
loadData(index,flag,pages){//获取数据方法
this.show_1 = true;

let comnCodes = '';
if(index == 0){
comnCodes = '';
}else if(index == 1){
comnCodes = this.comnCode;
}
let jsonData = {
goodsName:this.value,
comnCode: comnCodes,
firstflag: flag,
filters:[
{
filterId:$("#am_select3").find("button.weui-btn_primary").siblings(".am_nlow3").text(),
filterType:$("#am_select3").find("button.weui-btn_primary").siblings(".am_nlow4").text(),
},
{
filterId:$("#am_select2").find("button.weui-btn_primary").siblings(".am_nlow3").text(),
filterType:$("#am_select2").find("button.weui-btn_primary").siblings(".am_nlow4").text(),
filterRule:$("#am_select2").find("button.weui-btn_primary").siblings(".am_nlow1").text(),
filterValue:$("#am_select2").find("button.weui-btn_primary").siblings(".am_nlow2").text()
},
{
filterId:$("#am_select1").find("button.weui-btn_primary").siblings(".am_nlow3").text(),
filterType:$("#am_select1").find("button.weui-btn_primary").siblings(".am_nlow4").text(),
}
],
page:pages,
rows: 3,
isOffline:0,
goodsState:2
};
console.log("$$$$$$$$$$$$$$$$$$$$$$")
console.log(jsonData)
let url = global.host + 'secondMarket/findgoodslist';
this.$http.post(url,jsonData).then(function(res){

let picList = res.body.goods;
for(let mv in picList){
if(picList[mv].imgs.length>0){
for(let nv in picList[mv].imgs){
picList[mv].imgs[nv].minPicUrl = global.baseImg+picList[mv].imgs[nv].minPicUrl;
picList[mv].imgs[nv].maxPicUrl = global.baseImg+picList[mv].imgs[nv].maxPicUrl;
}
}
this.picList.push(picList[mv]);
}

this.show_1 = false;
$(".am_absolt").hide()


let mlist = res.body;
this.filter1 = new Object();
this.filter2 = new Object();
this.filter3 = new Object()
let st = '';
let sId = '';
let types = ''
for(let s in mlist[1]){
this.filter1[s] = mlist[1][s];
st = mlist[1][s].filterName;
sId = mlist[1][s].filterId;
types = mlist[1][s].filterType;
}

this.titles[2] = st;
this.fliterIds = sId;
this.fliterTypes = types;
console.log(this.titles)

for(let m in mlist[2]){
this.filter2[m] = mlist[2][m];
}
for(let n in mlist[3]){
this.filter3[n] = mlist[3][n];
}
if(jsonData.rows != res.body.goods.length){
document.getElementById("g1").removeEventListener('touup',this.touchup);
}
},function(err){
console.log(err)
})
}
}

}



// WEBPACK FOOTER //
// ./src/components/fleaMarketComponents/fleaMarketList.vue